<div class="ui-skeleton" [ngSwitch]="variant" role="status" aria-live="polite" aria-busy="true">
  <span class="ui-skeleton-sr-only">Carregando…</span>

  <ng-container *ngSwitchCase="'text'">
    <div
      class="ui-skeleton-line"
      *ngFor="let item of items; let last = last"
      [class.ui-skeleton-line-short]="last"
    ></div>
  </ng-container>

  <ng-container *ngSwitchCase="'card'">
    <div class="ui-skeleton-card">
      <div class="ui-skeleton-card-avatar"></div>
      <div class="ui-skeleton-card-body">
        <div class="ui-skeleton-line ui-skeleton-line-title"></div>
        <div class="ui-skeleton-line" *ngFor="let item of items"></div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'table-row'">
    <div class="ui-skeleton-row" *ngFor="let item of items">
      <div class="ui-skeleton-cell" *ngFor="let col of columnItems"></div>
    </div>
  </ng-container>
</div>
